export default "__VITE_ASSET__c4dba205__"